<template>
  <v-container class="profile-page">
    <v-row class="justify-center align-center pt-2 pb-6">
      <div class="text-center">
        <h1 class="page-title">โปรไฟล์ของฉัน</h1>
        <p class="page-subtitle mb-0">จัดการข้อมูลส่วนตัวและความปลอดภัยของบัญชีคุณ</p>
      </div>
    </v-row>

    <v-form @submit.prevent="submit">
      <!-- ===================== การ์ดรูปโปรไฟล์ + ชื่อ ===================== -->
      <v-card class="section-card mb-5" outlined rounded="lg">
        <v-card-text class="py-6">
          <v-row class="justify-center align-center">
            <v-col cols="12" sm="4" md="3" class="text-center">
              <div class="avatar-wrap">
                <v-avatar size="140" class="avatar-shadow">
                  <v-img :src="showpreviewimage"
                    lazy-src="https://upload.wikimedia.org/wikipedia/en/2/24/Crystal_personal.svg"
                    @error="onAvatarError" />
                </v-avatar>
                <v-btn fab x-small color="#0A7EA5" dark class="avatar-edit-btn" @click="$refs.file.click()">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <input type="file" accept="image/.png,.jpg" @change="previewMultiImage" ref="file"
                  style="display:none" />
              </div>
            </v-col>
            <v-col cols="12" sm="8" md="9">
              <h2 class="name-en">
                {{ dataaccount.prename_e_n }} {{ dataaccount.firstname_e_n }} {{ dataaccount.lastname_e_n }}
              </h2>
              <h3 class="name-th">
                {{ dataaccount.prename_t_h }} {{ dataaccount.firstname }} {{ dataaccount.lastname }}
              </h3>
              <div class="d-flex align-center flex-wrap mt-2">
              <v-chip small class="mr-4" color="#E1F5FE" text-color="#0A7EA5">
                <v-icon left small>mdi-account-circle</v-icon>
                {{ dataaccount.username }}
              </v-chip>
              <span class="mr-6 black--text"><b>Department:</b> {{ datadepartment.name || '-' }}</span>
              <span class="black--text"><b>Position:</b> {{ dataposition.name || '-' }}</span>
            </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- ===================== การ์ดข้อมูลติดต่อ ===================== -->
      <v-card class="section-card mb-5" outlined rounded="lg">
        <v-card-title class="section-title">
          <v-icon left color="#0A7EA5">mdi-card-account-details-outline</v-icon>
          ข้อมูลติดต่อ
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-5">
          <v-row>
            <v-col cols="12" sm="4" md="4">
              <v-text-field label="Telephone" prepend-inner-icon="mdi-phone-outline" v-model="account.phone" outlined
                dense></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field label="Email" prepend-inner-icon="mdi-email-outline" disabled background-color="#F5F5F5"
                v-model="dataaccount.email" outlined dense></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field label="Username" prepend-inner-icon="mdi-account-outline" disabled
                background-color="#F5F5F5" v-model="dataaccount.username" outlined dense></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- ===================== การ์ดลายเซ็น ===================== -->
      <v-card class="section-card mb-5" outlined rounded="lg">
        <v-card-title class="section-title">
          <v-icon left color="#0A7EA5">mdi-draw-pen</v-icon>
          ลายเซ็น
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-5">
          <v-row class="justify-center align-center">
            <v-col align="center" cols="12" md="6">
              <v-row :style="{ visibility: showsig1 ? 'visible' : 'hidden' }">
                <div class="signature-frame">
                  <VueSignaturePad class="signature" width="100%" height="150px" ref="firstsignaturePad" />
                </div>
                <v-row :style="{ visibility: showbuttonsavesig1 ? 'visible' : 'hidden' }">
                  <v-col align="center">
                    <v-btn depressed class="ml-5" @click="clearsig1()">
                      Clear
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-btn class="mr-5 mb-5 primary" depressed @click="savesig1()">
                      Save
                    </v-btn>
                  </v-col>
                </v-row>
              </v-row>
              <v-btn class="mr-2" @click="editsig1()">
                {{ defaultwordbuttonsig1 }}
                <v-icon right :style="{ backgroundColor: '#E1F5FE', color: '#2196F3' }">mdi-border-color</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- ===================== การ์ดความปลอดภัย: ยืนยันตัวตน + เปลี่ยนรหัสผ่าน (ทางเลือก) ===================== -->
      <v-card class="section-card mb-5" outlined rounded="lg">
        <v-card-title class="section-title">
          <v-icon left color="#0A7EA5">mdi-shield-lock-outline</v-icon>
          ความปลอดภัย
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-5">
          <p class="caption grey--text text--darken-1 mb-4">
            กรุณากรอก <strong>รหัสผ่านปัจจุบัน</strong> ทุกครั้งเพื่อยืนยันตัวตนก่อนบันทึกการเปลี่ยนแปลงข้อมูล
          </p>

          <v-row>
            <v-col cols="12" sm="4" md="4">
              <v-text-field class="heightsize60" name="current_password" label="Current Password *"
                id="current_password" v-model="account.currentpassword" prepend-inner-icon="mdi-lock-check-outline"
                :append-icon="isShowCurrentPassword ? 'visibility' : 'visibility_off'"
                @click:append="isShowCurrentPassword = !isShowCurrentPassword"
                :type="isShowCurrentPassword ? 'text' : 'password'" outlined dense
                hint="ใช้ยืนยันตัวตนก่อนบันทึกข้อมูลทุกครั้ง" persistent-hint />
            </v-col>
          </v-row>

          <v-divider class="my-5"></v-divider>

          <div class="d-flex align-center flex-wrap">
            <div>
              <div class="change-pass-label">
                <v-icon small color="#0A7EA5" class="mr-1">mdi-lock-reset</v-icon>
                ต้องการเปลี่ยนรหัสผ่านด้วยหรือไม่?
              </div>
              <div class="caption grey--text">เป็นทางเลือก ไม่บังคับ หากไม่ต้องการเปลี่ยนรหัสผ่าน สามารถข้ามส่วนนี้ได้
              </div>
            </div>
            <v-spacer></v-spacer>
            <v-btn :outlined="!showChangePassword" :color="showChangePassword ? 'error' : '#0A7EA5'"
              :text="showChangePassword" class="mt-2 mt-sm-0" @click="toggleChangePassword">
              <v-icon left small>{{ showChangePassword ? "mdi-close" : "mdi-lock-reset" }}</v-icon>
              {{ showChangePassword ? "ยกเลิกการเปลี่ยนรหัสผ่าน" : "เปลี่ยนรหัสผ่าน" }}
            </v-btn>
          </div>

          <v-expand-transition>
            <v-row v-if="showChangePassword" class="mt-4">
              <v-col cols="12" sm="6" md="6">
                <v-text-field class="heightsize60" name="password" label="New Password *" id="new_password"
                  v-model="account.password" prepend-inner-icon="mdi-lock-plus-outline"
                  :append-icon="isShowPassword ? 'visibility' : 'visibility_off'"
                  @click:append="isShowPassword = !isShowPassword" :type="isShowPassword ? 'text' : 'password'" outlined
                  dense hint="8+ ตัวอักษร, มีทั้งตัวพิมพ์เล็ก-ใหญ่, ตัวเลข และอักขระพิเศษ" persistent-hint />
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field class="heightsize60" name="confirm_password" label="Confirm New Password *"
                  id="confirm_password" v-model="account.confirm_password" prepend-inner-icon="mdi-lock-check-outline"
                  :append-icon="isShowPassword2 ? 'visibility' : 'visibility_off'"
                  @click:append="isShowPassword2 = !isShowPassword2" :type="isShowPassword2 ? 'text' : 'password'"
                  outlined dense />
              </v-col>
            </v-row>
          </v-expand-transition>
        </v-card-text>
      </v-card>

      <!-- ===================== ปุ่มบันทึก / ยกเลิก ===================== -->
      <v-row class="justify-center align-center mb-6">
        <v-col align="center" cols="12" md="12">
          <v-btn class="mr-3 mt-2 action-btn" width="200" dark type="submit" color="#0A7EA5" rounded elevation="2">
            <v-icon left>mdi-content-save-outline</v-icon>
            Save
          </v-btn>
          <v-btn @click="$router.back()" class="mr-3 mt-2 action-btn" width="200" outlined color="#FF3130" rounded>
            <v-icon left>mdi-close</v-icon>
            Cancel
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />

    <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message" :link="link" />

  </v-container>
</template>

<script>
import api from "@/services/api";
import { server, imageUrl } from "@/services/constants";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";

export default {
  async mounted() {
    await this.loaddata();
    await this.loaddepartment();
    await this.loadposition();
    this.$hideLoader();
  },
  components: { SuccessDialog, SuccessDialogPush },
  data() {
    return {
      defaultwordbuttonsig1: "My Signature",
      showbuttonsavesig1: false,
      showsig1: false,
      showpreviewimage: null,
      preview_image: null,
      image_data: null,
      dataaccount: [],
      datadepartment: [],
      dataposition: [],
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      dialogAdd: false,
      isShowCurrentPassword: false,
      isShowPassword: false,
      isShowPassword2: false,
      // ตัวควบคุมการแสดงช่อง New/Confirm Password (Current Password จะแสดงตลอด)
      showChangePassword: false,
      account: {
        currentpassword: "",
        password: "",
        confirm_password: "",
        phone: "",
        signature: "",
        oldimage: "",
      },
    };
  },
  computed: {},
  watch: {},
  methods: {
    // เปิด/ปิดโหมดเปลี่ยนรหัสผ่าน (เฉพาะ New/Confirm) และล้างค่าฟิลด์รหัสผ่านใหม่เมื่อยกเลิก
    // ตรวจรูปแบบรหัสผ่านใหม่: 8+ ตัวอักษร, มีตัวพิมพ์เล็ก-ใหญ่, ตัวเลข, อักขระพิเศษ
    isValidPassword(pwd) {
      const rule = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
      return rule.test(pwd);
    },
    toggleChangePassword() {
      this.showChangePassword = !this.showChangePassword;
      if (!this.showChangePassword) {
        this.account.password = "";
        this.account.confirm_password = "";
      }
    },
    async showdefaultsignature() {
      this.$nextTick(() => {
        this.$refs.firstsignaturePad.resizeCanvas();
        this.$refs.firstsignaturePad.fromDataURL(this.account.signature);

        this.$refs.firstsignaturePad.lockSignaturePad();
        this.$refs.firstsignaturePad.resizeCanvas();
        this.$refs.firstsignaturePad.lockSignaturePad();
      });
    },
    async clearsig1() {
      this.$refs.firstsignaturePad.resizeCanvas();
      this.$refs.firstsignaturePad.clearSignature();
      this.account.signature = "";
    },
    async savesig1() {
      this.defaultwordbuttonsig1 = "Edit";
      this.showbuttonsavesig1 = false;

      const { isEmpty, data } = this.$refs.firstsignaturePad.saveSignature();
      this.account.signature = data;
      this.$refs.firstsignaturePad.resizeCanvas();
      this.$refs.firstsignaturePad.fromDataURL(this.account.signature);
      this.showbuttonsavesig1 = false;
      this.$refs.firstsignaturePad.lockSignaturePad();
    },
    editsig1() {
      this.showsig1 = true;
      this.showbuttonsavesig1 = true;
      this.$refs.firstsignaturePad.resizeCanvas();
      this.$refs.firstsignaturePad.fromDataURL(this.account.signature);
      this.$refs.firstsignaturePad.openSignaturePad();
    },
    previewMultiImage: function (event) {
      this.filenameattach = [];
      var input = event.target;
      var count = input.files.length;
      var index = 0;
      if (input.files) {
        while (count--) {
          var reader = new FileReader();
          reader.onload = (e) => {
            this.preview_image = e.target.result;
            this.getImage(e.target.result, "preview");
          };
          if (input.files[index].type.split("/")[0] === "image") {
            this.image_data = input.files[index];
            reader.readAsDataURL(input.files[index]);
          }
          index++;
        }
      }
    },
        async loaddepartment() { 
        const result = await api.getDepartmentByID(
        this.dataaccount.department_i_d??0
        );
        this.datadepartment = result.data[0];
        },
        async loadposition() { 
        const result = await api.getAllPositionTranning(
        this.dataaccount.company_i_d??0 ,Number(this.dataaccount.department_i_d)??0
        );
        if (result.data.length > 0) {
        this.dataposition = result.data.find(item => String(item.id) === String(this.dataaccount.position_i_d));
        }
        },
    async loaddata() {
      const result = await api.getAccountid(
        localStorage.getItem(server.USER_ID)
      );
      if (result.data[0]) {
        this.dataaccount = result.data[0];
        this.account.phone = this.dataaccount.phone;
        this.account.signature = this.dataaccount.signature;
        this.account.oldimage = this.dataaccount.image || "";
        await this.getImage(null, "load");
        await this.showdefaultsignature();
        this.showsig1 = true;
      }
    },
    async getImage(data, type) {
      if (type == "load") {
        // กันทั้งกรณี image เป็น null/undefined/ว่างจริง และกรณี string "null"/"undefined"
        // ที่อาจหลงเหลืออยู่ใน DB จาก FormData แปลง null เป็น string ผิดพลาดในอดีต
        const img = this.dataaccount.image;
        if (!img || img === "null" || img === "undefined") {
          this.showpreviewimage = null;
          return null;
        }
        this.showpreviewimage = `${imageUrl}/${img}`;
        return `${imageUrl}/${img}`;
      } else {
        this.showpreviewimage = `${data}`;
        return `${data}`;
      }
    },
    // เรียกเมื่อ v-img โหลดรูปจริงไม่สำเร็จ (URL 404 / เสีย) ให้ fallback กลับไปเป็นรูป default
    onAvatarError() {
      this.showpreviewimage = null;
    },
    async submit() {
      // Current Password ต้องกรอกเสมอ ใช้ยืนยันตัวตนก่อนบันทึกทุกการเปลี่ยนแปลง (ทั้งข้อมูลส่วนตัวและรหัสผ่าน)
      if (this.account.currentpassword == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Input Current Password",
          "text-h5 red--text text-center"
        );
        return;
      }

      // ตรวจสอบฟิลด์รหัสผ่านใหม่ เฉพาะกรณีเปิดโหมดเปลี่ยนรหัสผ่านเท่านั้น
      if (this.showChangePassword) {
        if (this.account.password == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please Input New Password",
            "text-h5 red--text text-center"
          );
          return;
        }

        if (this.account.confirm_password == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please Input Confirm Password",
            "text-h5 red--text text-center"
          );
          return;
        }

        if (!this.isValidPassword(this.account.password)) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Password format invalid",
            "Password must contain: • 8+ characters • Uppercase and lowercase letters • A number • A special character",
            "text-h5 red--text text-center"
          );
          return;
        }

        if (this.account.password == this.account.currentpassword) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "New Password must not be the same as Current Password",
            "text-h5 red--text text-center"
          );
          return;
        }

        if (this.account.password != this.account.confirm_password) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Password and Confirm Password not match",
            "text-h5 red--text text-center"
          );
          return;
        }
      }

      let formData = new FormData();
      if (this.image_data) {
        formData.append("image", this.image_data);
      }
      // ส่ง currentpassword ไปยืนยันตัวตนเสมอ ส่ง password ใหม่เฉพาะกรณีเปิดโหมดเปลี่ยนรหัสผ่าน
      formData.append("currentpassword", this.account.currentpassword);
      if (this.showChangePassword && this.account.password !== "") {
        formData.append("password", this.account.password);
      }
      formData.append("phone", this.account.phone);
      formData.append("signature", this.account.signature);
      formData.append("oldimage", this.account.oldimage || "");
      this.$showLoader();
      try {
        const res_reset = await api.updateMyprofileWebv2(
          localStorage.getItem(server.USER_ID),
          formData
        );

        // backend ตอบ HTTP 200 เสมอทุกกรณี (สำเร็จ/ไม่สำเร็จ) เพื่อเลี่ยง interceptor ที่ดัก
        // non-2xx แล้ว redirect ไป dashboard/logout ผลลัพธ์จริงต้องดูจาก data.ok แทน
        if (res_reset.data && res_reset.data.ok) {
          // ต้องจับค่านี้ไว้ก่อน เพราะด้านล่างจะรีเซ็ต showChangePassword เป็น false ทันที
          const passwordWasChanged = this.showChangePassword;

          this.$hideLoader()
          this.$store.state.global_dialog = true;

          // ล้างฟิลด์รหัสผ่านทุกกรณีหลังบันทึกสำเร็จ เพื่อความปลอดภัย
          this.account.currentpassword = "";
          this.account.password = "";
          this.account.confirm_password = "";
          this.showChangePassword = false;
          this.image_data = null;

          if (passwordWasChanged) {
            // กรณีเปลี่ยนรหัสผ่านสำเร็จ -> ต้องบังคับ logout ทันที ไม่ reload ข้อมูลต่อ
            // เพราะ session/token เดิมควรถือว่าไม่ปลอดภัยอีกต่อไปหลังรหัสผ่านเปลี่ยน
            this.setupAlertDialogPush(
              true,
              "Success",
              "เปลี่ยนรหัสผ่านสำเร็จ ระบบจะให้คุณเข้าสู่ระบบใหม่อีกครั้ง",
              "text-h5 green--text text-center",
            );
            this.forceLogoutAfterPasswordChange();
            return;
          }

          this.setupAlertDialogPush(
            true,
            "Success",
            "Update data success",
            "text-h5 green--text text-center",
          );

          // โหลดข้อมูลล่าสุด (เช่น เบอร์โทร, รูปโปรไฟล์ที่เพิ่งอัปโหลด) กลับมาแสดงใหม่
          this.$showLoader();
          await this.loaddata();
          this.$hideLoader();
        } else {
          this.$hideLoader()
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            this.mapErrorMessage(res_reset),
            "text-h5 red--text text-center"
          );
        }
      } catch (error) {
        // ดักกรณีเรียก API ไม่สำเร็จ (network error, timeout ฯลฯ) ไม่ให้หน้าจอค้างเฉยๆ
        this.$hideLoader()
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          this.mapErrorMessage(error && error.response ? error.response : null),
          "text-h5 red--text text-center"
        );
      }
    },
    // แปล message จาก backend ให้เป็นข้อความที่ user เข้าใจง่าย
    // (backend ตอบ HTTP 200 เสมอทุกกรณีแล้ว จึงอิงจาก "เนื้อหา message" ล้วนๆ ไม่ใช่ status code)
    mapErrorMessage(res) {
      const backendMessage = res && res.data && res.data.message ? res.data.message : "";

      if (/current password/i.test(backendMessage)) {
        return "รหัสผ่านปัจจุบันไม่ถูกต้อง";
      }
      if (/account not found/i.test(backendMessage)) {
        return "ไม่พบข้อมูลบัญชีผู้ใช้งาน";
      }
      if (backendMessage) {
        return backendMessage;
      }
      return "บันทึกข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง";
    },
    // บังคับ logout หลังเปลี่ยนรหัสผ่านสำเร็จ หน่วงเวลาสั้นๆ ให้ user เห็น dialog สำเร็จก่อน redirect
    // *** สมมติฐาน: ล้าง localStorage แล้วเด้งไปหน้า /login เพราะไม่รู้ว่าระบบจริงมี
    // action logout ของ store หรือ api.logout() อยู่แล้วหรือไม่ ถ้ามีอยู่แล้วรบกวนบอก
    // จะได้เปลี่ยนมาเรียกอันนั้นแทน เพื่อให้ล้าง state อื่นๆ (เช่น user profile ใน store) ครบด้วย ***
    forceLogoutAfterPasswordChange() {
      setTimeout(() => {
        localStorage.removeItem(server.USER_ID);
        localStorage.removeItem("token");
        this.$router.push("/login");
      }, 1800);
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
  async beforeCreate() {
    this.$store.state.navMenu = true;
  },
};
</script>

<style scoped>
.profile-page {
  max-width: 1000px;
}

.page-title {
  color: #0A7EA5;
  font-weight: 700;
  margin-bottom: 4px;
}

.page-subtitle {
  color: #78909C;
  font-size: 14px;
  margin-bottom: 0;
}

.section-card {
  border-radius: 14px !important;
  box-shadow: 0 2px 10px rgba(10, 126, 165, 0.06) !important;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #0A7EA5;
}

.avatar-wrap {
  position: relative;
  display: inline-block;
}

.avatar-shadow {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
  border: 3px solid #FFFFFF;
}

.avatar-edit-btn {
  position: absolute;
  bottom: 4px;
  right: 4px;
}

.name-en {
  color: #263238;
  font-weight: 600;
}

.name-th {
  color: #607D8B;
  font-weight: 500;
  font-size: 15px;
}

.change-pass-label {
  font-weight: 600;
  color: #263238;
  display: flex;
  align-items: center;
}

.action-btn {
  text-transform: none;
  font-weight: 600;
}

.signature-frame {
  width: 100%;
  height: 150px;
  border: 2px solid #1976D2;
  border-radius: 6px;
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
}

.signature-frame>>>canvas,
.signature-frame ::v-deep canvas {
  display: block;
  width: 100% !important;
  height: 100% !important;
  border: none !important;
  box-sizing: border-box;
}

.heightsize60 {
  height: 60px;
}

.heightsize40 {
  height: 40px;
}

.theme--light.v-divider {
  border-color: rgba(0, 0, 0, 0.12) !important;
}
</style>